import { DotBtn } from 'Components/Molecules/DotBtn/DotBtn';
import Modal from 'Components/Molecules/Modals/Modal/Modal';
import ModalFooter from 'Components/Molecules/Modals/ModalFooter/ModalFooter';
import ModalHeader from 'Components/Molecules/Modals/ModalHeader/ModalHeader';
import { useEffect, useState } from 'react';
import DotBtnItem from '../DotBtnItem/DotBtnItem';
import Spinner from '../Spinner/Spinner';
import Title from '../Title/Title';
import EditorCloseIcon from '@atlaskit/icon/glyph/editor/close';
import EditorDoneIcon from '@atlaskit/icon/glyph/editor/done';
import EditorEditIcon from '@atlaskit/icon/glyph/editor/edit';
import Container from '../Container/Container';
import Button from '../Button/Button';
import { default as ButtonDeprecated } from '../ButtonDeprecated/Button';
import ButtonGroup from 'Components/Molecules/ButtonGroup/ButtonGroup';

const EditButtons = ({
        children,
        onEdit,
        onSave,
        onCancel,
        isLoading,
        isDropdown,
        onDelete,
        deleteDescription,
        defaultEdit,
        onDeleteOpen,
        isDeleteDisabled,

        isEdit: parentEdit
    }: any) => {
    const [isEdit, setEdit] = useState(defaultEdit ? true : false);
    const [isDeleting, setDeleting] = useState(false);

    useEffect(() => {
        setEdit(parentEdit);
    }, [parentEdit]);

    useEffect(() => {
        if (onDeleteOpen) {
            onDeleteOpen(isDeleting);
        }
    }, [isDeleting]);

    const handleEdit = () => {
        setEdit(!isEdit);
        onEdit(!isEdit);
    }
    const handleSave = () => {
        if (parentEdit == undefined) {
            setEdit(false);
            onEdit(false);
        }
        onSave();
    }
    const handleCancel = () => {
        if (parentEdit == undefined) {
            setEdit(false);
            onEdit(false);
        }
        onCancel();
    }
    const handleDelete = () => {
        onDelete();
    }

    useEffect(() => {
        if (isDeleting && !isLoading) {
            setDeleting(false);
        }
    }, [isLoading]);

    return <>
        { isLoading && <Spinner /> }
        { !isLoading && <>
            {
                !isDropdown && !isEdit &&
                    <ButtonGroup>
                        <ButtonDeprecated
                            appearance='subtle'
                            style={{borderRadius: '100%'}}
                            iconBefore={<EditorEditIcon primaryColor={'#97969E'} label="edit" size="medium"/>}
                            onClick={handleEdit}
                        />
                    </ButtonGroup>
            }
            {
                isDropdown && !isEdit &&
                    <DotBtn>
                        { onEdit && <DotBtnItem name={'Bewerken'} onClick={handleEdit}/> }
                        { children }
                        { onDelete && <DotBtnItem name={'Verwijderen'} css={'warning'} onClick={() => setDeleting(true)}/> }
                    </DotBtn>
            }
            {
                isEdit &&
                    <ButtonGroup wrap='nowrap'>
                        <ButtonDeprecated
                            appearance='subtle'
                            style={{borderRadius: '100%'}}
                            iconBefore={<EditorDoneIcon primaryColor={'#36B37E'} label="edit" size="medium"/>}
                            onClick={handleSave}
                        />
                        
                        <ButtonDeprecated
                            appearance='subtle'
                            style={{borderRadius: '100%'}}
                            iconBefore={<EditorCloseIcon primaryColor={'#FF5630'} label="edit" size="medium"/>}
                            onClick={handleCancel}
                        />
                    </ButtonGroup>
            }
        </> }
        {
            isDeleting && <Modal>
                <ModalHeader>
                    <Title size='large' weight='bold'>Weet je het zeker dat je dit wilt verwijderen?</Title>
                </ModalHeader>

                {
                    deleteDescription && <Container padding='vertical'>
                        { deleteDescription }
                    </Container>
                }

                <ModalFooter>
                    <ButtonGroup>
                        { !isLoading && <Button
                            variant='transparent'
                            onClick={() => setDeleting(false)}
                        >
                            Annuleren
                        </Button> }
                        <Button 
                            variant='solid'
                            color='primary'
                            isLoading={isLoading}
                            onClick={handleDelete}
                            isDisabled={isDeleteDisabled}
                        >
                            Verwijderen
                        </Button>
                    </ButtonGroup>
                </ModalFooter>
            </Modal>
        }
    </>
}

export default EditButtons;